import React from 'react';

const QuarryIcon = (props) => {
  return (
    <img
      alt="Kamieniołom"
      src="/static/images/icons/tourist_attractions/quarry.svg"
      {...props}
    />
  );
};

export default QuarryIcon;
